(function ($) {
  Drupal.behaviors.sppProductDetails = {
    isDesktop: true,

    attach: function (context) {
      var self = this;

      self.bps = Unison.fetch.all();
      self.bp = Unison.fetch.now();
      self.isDesktop = parseInt(self.bp.width, 10) >= parseInt(self.bps.medium, 10);
      Unison.on('change', function (bp) {
        self.bp = Unison.fetch.now();
        self.isDesktop = parseInt(self.bp.width, 10) >= parseInt(self.bps.medium, 10);
      });

      var $formatters = $('.product-details', context);
      var $productBenefits = $('.js-product-details__section--details', $formatters);
      var $productBenefitsIcons= $('.js-product-benefits-v1', $productBenefits);
      var $productBenefitsDetails = $('.js-product-details-benefits', $productBenefits);
      $productBenefitsDetails.html($productBenefitsIcons);
      if (!($productBenefits)) {
        $productBenefitsDetails.remove();
      }
      $formatters.each(function (i, obj) {
        var $formatter = $(obj);
        var $menu = $('.js-product-details__menu', $formatter);
        var $sections_carousel = $('.js-product-details__sections', $formatter);
        var $menuSlides = $('.product-details__menu-title', $menu);
        var settings = {
          slide: '.product-details__section',
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: $menu,
          arrows: false,
          dots: false,
          fade: true,
          adaptiveHeight: true,
          rows: 0,
          waitForAnimate: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                fade: false,
                adaptiveHeight: false
              }
            }
          ]
        };
        var menu_settings = {
          slide: '.product-details__menu-title',
          infinite: false,
          slidesToScroll: 1,
          asNavFor: $sections_carousel,
          arrows: false,
          dots: false,
          focusOnSelect: true,

          centerMode: false,
          slidesToShow: $menuSlides.length,
          centerPadding: '0px',
          variableWidth: false,
          rows: 0,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                centerMode: true,
                centerPadding: '30vw',
                slidesToShow: 1,
                infinite: true
              }
            }
          ]
        };

        if ($menuSlides.length <= 2) {
          menu_settings['responsive'][0]['settings']['centerMode'] = false;
          menu_settings['responsive'][0]['settings']['infinite'] = false;
          menu_settings['responsive'][0]['settings']['slidesToShow'] = $menuSlides.length;
        }

        $menu.slick(menu_settings);

        $sections_carousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
          // slick-current isn't set with asNavFor when the menu slick is
          // showing all slides.
          $('.product-details__menu-title', $menu).removeClass('slick-current');
          $('.product-details__menu-title[data-slick-index=' + nextSlide + ']', $menu).addClass('slick-current');
          // hack for now. remove the expanded classon items
          // console.
          $('.product-detail-item', $sections_carousel).removeClass('product-detail-item--text-expanded');

          var $current = $('.product-details__section[data-slick-index=' + nextSlide + ']', $sections_carousel);
          var $item = $('.product-detail-item', $current);
          var bgImage = $item.data('background-image');

          if (bgImage) {
            $sections_carousel.css('background-image', 'url(' + bgImage + ')');
          } else {
            $sections_carousel.css('background-image', '');
          }
        });
        $sections_carousel.on('afterChange', function (event, slick, currentSlide, nextSlide) {});

        _mantle_media_fix_video_carousel($sections_carousel, settings['slide']);
        $sections_carousel.slick(settings);
      });
    }
  };
})(jQuery);
